import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import UserMenu from './UserMenu';

const Navbar = ({ onMenuToggle, user }) => {
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Hamburger - Absolute positioned so it doesn't affect logo position */}
          {isAdminPage && onMenuToggle && (
            <button
              onClick={onMenuToggle}
              className="absolute left-4 p-2 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-slate-500 transition-colors duration-200"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}

          {/* Logo/Brand - Consistent position */}
          <div className="flex items-center flex-shrink-0">
            <Link to="/" className="flex items-center">
              <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
              <span className="ml-2 text-slate-800 text-xl font-semibold">For Anything Properties</span>
            </Link>
          </div>

          {/* Desktop Navigation or Admin Actions */}
          <div className="flex items-center space-x-4">
            {isAdminPage && user && (
              <UserMenu user={user} userType="admin" />
            )}
          </div>
        </div>
      </div>

    </nav>
  );
};

export default Navbar;
